module.exports = __webpack_public_path__ + "static/freeapp-flag-7526500c38b10fa988d5c320207d997c.png";